import type { PageProps, UniversalPaymentAccountPageProps } from "@/types";
import React, { FC } from "react";
import {
  UniversalPaymentAccountConfigurationAndStructure,
  UniversalPaymentAccountHero,
  UniversalPaymentAccountPreventingFraud,
  UniversalPaymentAccountUPA,
  UniversalPaymentAccountUPAForSendersAndRecipients,
} from "../universal-payment-account";
import { NextPage } from "../next-page";

export const UniversalPaymentAccount: FC<
  PageProps<UniversalPaymentAccountPageProps>
> = (props) => {
  return (
    <div>
      <UniversalPaymentAccountHero
        label={props.meta.translation.solutions.hero.label}
        title={props.data.title}
        description={props.data.description}
        cover={props.data.cover}
      />
      <UniversalPaymentAccountUPA
        content={props.data.upaContent}
        cover={props.data.upaCover}
      />
      <UniversalPaymentAccountPreventingFraud {...props.data.preventingFraud} />
      <UniversalPaymentAccountUPAForSendersAndRecipients
        content={props.data.upaForSendersAndRecipientsContent}
        cover={props.data.upaForSendersAndRecipientsCover}
      />
      <UniversalPaymentAccountConfigurationAndStructure
        content={props.data.configurationAndStructureContent}
        cover={props.data.configurationAndStructureCover}
      />
      <NextPage {...props.data.nextPage} />
    </div>
  );
};
